<template>
  <div class="action-menu">
    <div
      v-if="!liked"
      class="like-btn"
      @click="createLike()"
    >
      <i class="fas fa-heart"></i>
    </div>
    <div
      v-else
      class="unlike-btn"
      @click="deleteLike()"
    >
      <i class="fas fa-heart"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { csrfToken } from 'rails-ujs'
import * as Sentry from '@sentry/vue'

export default {
  name: 'FanLetterLikeButton',
  props: {
    fanLetterId: {
      type: Number,
      required: true
    },
    like: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      liked: this.like
    }
  },
  created () {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': csrfToken()
    }
  },
  methods: {
    createLike () {
      axios.post('/api/fan_letter_likes', { id: this.fanLetterId }
      ).then(() => (this.liked = true)
      ).catch(error => (Sentry.captureException(error)))
    },
    deleteLike () {
      axios.delete(`/api/fan_letter_likes/${this.fanLetterId}`
      ).then(() => (this.liked = false)
      ).catch(error => (Sentry.captureException(error)))
    }
  }
}
</script>
